import { type FC } from 'react';

import styles from '../MatchmakingModal.module.scss';

export const MetadataPillSeparator: FC = () => (
  <div className={styles.metadataPillSeparator} />
);
